import { TROUBLESHOOTING_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/troubleshooting_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator(['troubleshootingIndex']);
export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
